import {createApi, retry} from '@reduxjs/toolkit/query/react'

import {prepareBoVioHeaders} from '../../../booking/utils/prepareBovioHeaders'
import {
  fetchBaseQuery,
  FetchBaseQueryFnWithRetry,
  Method
} from '../../../utils/network/fetchBaseQuery'
import {
  CreatePaymentSessionRequest,
  PaymentSessionResponse,
  PaymentSettings,
  PaymentSettingsRequest
} from '../../types/paymentSettings'

const baseQueryWithRetry: FetchBaseQueryFnWithRetry = retry(
  fetchBaseQuery({baseUrl: ''}),
  {maxRetries: 3}
)

export const paymentSettingsApi = createApi({
  reducerPath: 'paymentSettingsApi',
  baseQuery: baseQueryWithRetry,
  endpoints: builder => ({
    getPaymentSettings: builder.query<PaymentSettings, PaymentSettingsRequest>({
      keepUnusedDataFor: 300,
      query: ({url, ...rest}) => ({
        url,
        headers: prepareBoVioHeaders(rest)
      })
    }),
    createPaymentSession: builder.mutation<
      PaymentSessionResponse,
      CreatePaymentSessionRequest
    >({
      query: ({link, ...rest}) => ({
        url: link.href,
        method: link.method as Method,
        headers: prepareBoVioHeaders(rest)
      }),
      // Each call creates a session, so a retry could leave orphaned ones.
      extraOptions: {maxRetries: 0}
    })
  })
})

export const {useGetPaymentSettingsQuery} = paymentSettingsApi
